"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyleParamGetter = void 0;
var types_1 = require("../../../types");
var generateKey_1 = require("../../../generateKey");
function createStyleParamGetter(_a) {
    var storage = _a.storage, textPresets = _a.textPresets, colors = _a.colors, isMobile = _a.isMobile;
    var getNumberParam = function (key) {
        return (storage.numbers || {})[key];
    };
    var getBooleanParam = function (key) {
        return (storage.booleans || {})[key];
    };
    var getFontParam = function (key) {
        return (storage.fonts || {})[key];
    };
    var getColorParam = function (key) {
        return (storage.colors || {})[key];
    };
    return function (param) {
        var _a;
        var getter = (_a = {},
            _a[types_1.StyleParamType.Number] = getNumberParam,
            _a[types_1.StyleParamType.Boolean] = getBooleanParam,
            _a[types_1.StyleParamType.Font] = getFontParam,
            _a[types_1.StyleParamType.Color] = getColorParam,
            _a)[param.type];
        var key = param.key || param.name;
        var generatedKey = generateKey_1.generateKey(key, { isMobile: isMobile });
        var value = getter(generatedKey);
        if (generatedKey !== key && typeof value === 'undefined') {
            value = getter(key);
        }
        if (typeof value === 'undefined' && param.getDefaultValue) {
            return param.getDefaultValue({ colors: colors, textPresets: textPresets });
        }
        return value;
        // https://github.com/microsoft/TypeScript/issues/31663
        return value;
    };
}
exports.createStyleParamGetter = createStyleParamGetter;
//# sourceMappingURL=createStyleParamGetter.js.map